module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_pin-601af74a8b6a410d8f04af32545dde6c.svg";